<template>
    <div class="transfer-files-general">
        <div class="alert alert-info" role="alert" v-if="isLoading">
            Laden...
        </div>
        <div class="accordion" v-if="categories.length > 0">
            <div class="accordion-body px-0">
                <div class="list-group list-group-flush mb-4"
                     v-bind:key="key" v-for="(category, key) in categories">
                    <div class="list-group-item fw-bold">
                        <div class="d-flex align-items-center me-4">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-md-6 text-truncate">{{ category.name }}</div>
                                    <div class="col-md d-none d-md-block">Datum gewijzigd</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        v-bind:key="keyD" v-for="(file, keyD) in category.files"
                    >
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-md-6 text-truncate">{{ file.name }}</div>
                                    <div class="col-auto col-md mobile-font-muted mobile-font-small">{{ file.updated_at }}</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span @click="downloadFile(file.id, file.name, file.hash)">
                                <icon name="download" :fontSize="'1.5rem'"></icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="!isLoading">
            <div class="alert alert-info">
                Geen documenten beschikbaar
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon'
import { downloadBase64File } from '@/helpers/DownloadFile.js'

export default {
    name: 'TransferFilesGeneral',
    components: {
        Icon
    },
    data() {
        return {
            isLoading: false,
            categories: []
        }
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        },
    },
    created() {
        window.novict = {
            device: {
                device_token: this.deviceToken
            },
            session: {
                session_token: this.session.session_token
            }
        }
        this.getData()
    },
    methods: {
        getData() {
            this.isLoading = true
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post('/information-pages', {
                idEstablishment: this.$store.getters.selectedEstablishment.id,
                idGroup: this.$store.getters.selectedGroupsQueryString
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.categories = response.categories
                }
                this.isLoading = false
            })
        },
        downloadFile(idFile, filename, hash) {
            this.isLoading = true
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post('/download-document', {
                idFile: idFile,
                hash: hash
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response && response.fileContent !== null) {
                    downloadBase64File(filename, response.fileContent)
                }
                this.isLoading = false
            })
        },
    }
}
</script>

<style scoped>
.table .row {
    border-top: 1px solid #dee2e6;
}
.table .row.table-header {
    border-bottom: 2px solid #dee2e6;
}
.table .row.table-header + .row {
    border-top: 0;
}
</style>